import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessData,
  V3ApiError,
} from 'javascripts/services/v3ApiClient';

import { PUBLIC_PROFILE_TAGS_QUERY_KEY } from '../constants';

export type GetPublicProfileTagsResponse = V3ApiSuccessData<{
  industries: { id: number; slug: string; name: string }[];
  serviceAreas: { id: number; slug: string; name: string }[];
}>;

export const useGetPublicProfileTags = ({
  profileId,
}: {
  profileId?: number;
}) => {
  return useQuery<GetPublicProfileTagsResponse, V3ApiError>({
    queryFn: async () => {
      const response = await request({
        url: `/companies/public_profiles/${profileId}/tags`,
      });
      return response.data;
    },
    queryKey: [PUBLIC_PROFILE_TAGS_QUERY_KEY, profileId],
    enabled: !!profileId,
  });
};
